export default __webpack_public_path__ + "static/media/opened.10fc8f7c.png";